import axios from '@/jslib/axios'

export const getMicropolicyList = params => {
  return axios({
    method: 'get',
    url: '/admin/covid/list',
    params
  })
}

export const getMicropolicyDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/covid/policy/detail',
    params
  })
}

export const covidVoidPolicy = data =>{
  return axios({
    method: 'post',
    url: '/admin/covid/void/policy',
    data
  })
}

export const getPolicyExportList = params => {
  return axios({
    method: 'get',
    url: '/admin/covid/export/list',
    responseType: 'blob',
    params,
    timeout: 120000
  })
}

export const getIndicaidList = params => {
  return axios({
    method: 'get',
    url: '/admin/indicaid/list',
    params
  })
}

export const getIndicaidDetail = ({indicaid_id}) => {
  return axios({
    method: 'get',
    url: `/admin/indicaid/detail?indicaid_id=${indicaid_id}`,
  })
}

export const markShipped = data => {
  return axios({
    method: 'post',
    url: '/admin/indicaid/mark/shipped',
    data
  })
}

export const editTracking = data => {
  return axios({
    method: 'post',
    url: '/admin/indicaid/edit/track',
    data
  })
}

export const revertPreparing = data => {
  return axios({
    method: 'post',
    url: '/admin/indicaid/shipped/rollback',
    data
  })
}

export const addRemark = data => {
  return axios({
    method: 'post',
    url: '/admin/indicaid/remark/add',
    data
  })
}

export const purchaseListExport = params => {
  return axios({
    method: 'get',
    url: '/admin/indicaid/export/list',
    responseType: 'blob',
    params,
    timeout: 120000
  })
}

export const importExcel = data => {
  return axios({
    method: 'post',
    url: '/admin/indicaid/import/track',
    headers: { 'Content-Type': 'multipart/form-data' },
    data
  })
}

export const getExcelList = params => {
  return axios({
    method: 'get',
    url: '/admin/indicaid/import/list',
    params
  })
}

export const getKFLMList = params => {
  return axios({
    method: 'get',
    url: '/admin/kflm/list',
    params
  })
}

export const KFLMListExport = params => {
  return axios({
    method: 'get',
    url: '/admin/kflm/export/list',
    responseType: 'blob',
    params
  })
}

export const recepitDownload = data => {
  return axios({
    method: 'post',
    url: '/admin/indicaid/download/rec',
    responseType: 'blob',
    data
  })
}

export const getRedeemList = (params, other) => {
  return axios({
    method: 'get',
    url: '/admin/redeem/voucher/list',
    params,
    ...other
  })
}

export const getRedeemDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/redeem/voucher/detail',
    params
  })
}

export const HDAddRemark = data => {
  return axios({
    method: 'post',
    url: '/admin/redeem/voucher/remark/add',
    data
  })
}

export const HDMarkShipped = data => {
  return axios({
    method: 'post',
    url: '/admin/redeem/voucher/mark/shipped',
    data
  })
}

export const HDEditTracking = data => {
  return axios({
    method: 'post',
    url: '/admin/redeem/voucher/edit/track',
    data
  })
}

export const HDRevertPreparing = data => {
  return axios({
    method: 'post',
    url: '/admin/redeem/voucher/shipped/rollback',
    data
  })
}

export const getEwalletDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/ewallet/policy/detail',
    params
  })
}

export const getGiftPackList = params => {
  return axios({
    method: 'get',
    url: '/admin/gift/pack/list',
    params
  })
}

export const getGiftPackDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/gift/pack/detail',
    params
  })
}

export const getSportDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/sport/policy/detail',
    params
  })
}
export const getMobileDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/mobile/protection/policy/detail',
    params
  })
}
export const mobileAdjustPolicy = data => {
  return axios({
    method: 'post',
    url: '/admin/mobile/protection/adjust/policy',
    data
  })
}
export const mobileEndorsePolicy = data => {
  return axios({
    method: 'post',
    url: '/admin/mobile/protection/endorse/policy',
    data
  })
}
export const mobileMakeIssued = data => {
  return axios({
    method: 'post',
    url: '/admin/mobile/protection/make/issued',
    data
  })
}
export const mobileMakeRefund = data => {
  return axios({
    method: 'post',
    url: '/admin/mobile/protection/refund/overdue',
    data
  })
}
export const giftAddRemark = data => {
  return axios({
    method: 'post',
    url: '/admin/gift/pack/remark/add',
    data
  })
}

export const getRefferTalksList = (params, other) => {
  return axios({
    method: 'get',
    url: '/admin/programme/seminars/users/list',
    params,
    ...other
  })
}

export const getQrCodeList = params => {
  return axios({
    method: 'get',
    url: '/admin/subscribe/code/list',
    params
  })
}

export const addQrCode = data => {
  return axios({
    method: 'post',
    url: '/admin/subscribe/add/code',
    data
  })
}

export const delQrCode = data => {
  return axios({
    method: 'delete',
    url: '/admin/subscribe/del/code',
    data
  })
}

export const getTalkUserDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/programme/seminars/users/detail',
    params
  })
}

export const talkAddRemark = data => {
  return axios({
    method: 'post',
    url: '/admin/programme/seminars/users/add/remark',
    data
  })
}

export const campaignCreateLink = data => {
  return axios({
    method: 'post',
    url: '/admin/campaign/create/link',
    data
  })
}

export const getCampaginLinkList = params => {
  return axios({
    method: 'get',
    url: '/admin/campaign/link/list',
    params
  })
}

export const campaginDelLink = data => {
  return axios({
    method: 'delete',
    url: '/admin/campaign/delete/link',
    data
  })
}
export const getInfectiousDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/infectious/policy/detail',
    params
  })
}
export const getOverseaPaDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/overseas/pa/policy/detail',
    params
  })
}
